import { Stack, Typography } from '@mui/material'
import React from 'react'
import { getFormattedTimeSpanFromString } from '../../utils/global-utils'
import CustomTextField from './CustomTextField'

interface TimeSpanTextFieldProps {
    value: string
    onChange: (value: string) => void
    label?: string
    isSmall?: boolean
    width?: string
    centered?: boolean
    minWidth?: string
}

const TimeSpanTextField: React.FC<TimeSpanTextFieldProps> = ({
    value,
    onChange,
    label,
    isSmall,
    width,
    centered,
    minWidth = '150px'
}: TimeSpanTextFieldProps) => {
    const splitedValue = getFormattedTimeSpanFromString(value).split(':')
    const hours = Number(splitedValue[0])
    const minutes = Number(splitedValue[1])

    const handleHoursChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if(isNaN(Number(event.target.value))) return
        if (Number(event.target.value) < 0) {
            return
        }
        onChange(`${event.target.value}:${minutes}:00`)
    }

    const handleMinutesChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if(isNaN(Number(event.target.value))) return
        if (Number(event.target.value) > 59 || Number(event.target.value) < 0) {
            return
        }
        onChange(`${hours}:${event.target.value}:00`)
    }

    return (
        <Stack minWidth={minWidth} alignItems={centered ? 'center' : 'start'}>
            {label && (
                <Typography variant='body1' mb={1}>
                    {label}
                </Typography>
            )}
            <Stack direction='row' alignItems='center' justifyContent='start' spacing={1}>
                <CustomTextField
                    style={{
                        maxWidth: width ?? '120px',
                    }}
                    size='small'
                    isSmall={isSmall}
                    value={hours !== null && hours !== undefined && hours !== 0 ? hours : ''}
                    onChange={handleHoursChange}
                />
                <Typography>:</Typography>
                <CustomTextField
                    style={{
                        maxWidth: width ?? '120px',
                    }}
                    size='small'
                    isSmall={isSmall}
                    value={minutes !== null && minutes !== undefined && minutes !== 0 ? minutes : ''}
                    onChange={handleMinutesChange}
                />
            </Stack>
        </Stack>
    )
}

export default TimeSpanTextField
